import {
  BaseHeader,
  ContentMatchingHeader,
  EmptyHeader,
  SelectionHeader,
  SortableHeader,
  SummaryTitleHeader,
  TitleHeader,
} from 'features/dashboard/table/column/DashboardHeaders'
import {
  AdGroupCell,
  CampaignCell,
  CampaignTypeCell,
  DateCell,
  IdCell,
  OnOffCell,
  OperationStatusCell,
  ReviewStatusCell,
  SelectionCell,
} from 'features/dashboard/table/column/DashboardCells'
import {
  ExposureStatusCell,
  KeywordBiddingAmountCell,
  KeywordBiddingAmountEditCell,
  KeywordNameCell,
  LandingUrlCell,
  LandingUrlEditCell,
  LandingUrlSettingCell,
  QiCell,
} from './KeywordCells'
import { extraMetricColumns } from 'features/dashboard/table/column/DashboardColumns'
import { EtcColumns, GeneralColumns } from '../../../../Columns'

/**
 * @file 키워드 테이블 칼럼
 * @see https://wiki.daumkakao.com/pages/viewpage.action?pageId=818963305
 */

export const KeywordFixedColumns = [
  {
    accessor: 'id',
    sticky: 'left',
    Header: SelectionHeader,
    columns: [
      {
        accessor: 'id',
        Header: EmptyHeader,
        columns: [
          {
            accessor: 'id',
            width: 50,
            Header: EmptyHeader,
            Cell: SelectionCell,
          },
        ],
      },
    ],
  },
  {
    accessor: 'text',
    sticky: 'left',
    Header: TitleHeader,
    columns: [
      {
        accessor: 'text',
        Header: SummaryTitleHeader,
        columns: [
          {
            accessor: 'text',
            width: 370,
            Header: ContentMatchingHeader,
            Cell: KeywordNameCell,
          },
        ],
      },
    ],
  },
  {
    accessor: 'status',
    Header: SortableHeader,
    title: 'ON/OFF',
    columns: [
      {
        accessor: 'status',
        Header: EmptyHeader,
        columns: [
          {
            accessor: 'status',
            width: 91,
            Header: EmptyHeader,
            Cell: OnOffCell,
          },
        ],
      },
    ],
  },
]

export const KeywordConfigurableColumns = [
  {
    accessor: GeneralColumns.operationStatus.name,
    Header: BaseHeader,
    title: GeneralColumns.operationStatus.displayName,
    tooltip: (
      <>
        키워드 게재와 관련된 현재 상태를 의미합니다.
        <br />
        상위 광고그룹의 상태를 고려하여 현재 키워드의 최종 운영 상태를
        표기합니다.
      </>
    ),
    columns: [
      {
        accessor: GeneralColumns.operationStatus.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.operationStatus.name,
            width: 180,
            Header: EmptyHeader,
            Cell: OperationStatusCell,
          },
        ],
      },
    ],
  },
  {
    accessor: GeneralColumns.campaignType.name,
    Header: SortableHeader,
    title: GeneralColumns.campaignType.displayName,
    tooltip:
      '캠페인 유형을 통하여 원하는 목표를 달성하는데 적합한 캠페인, 광고그룹, 키워드, 소재 설정을 제공합니다.',
    columns: [
      {
        accessor: GeneralColumns.campaignType.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.campaignType.name,
            width: 130,
            Header: EmptyHeader,
            Cell: CampaignTypeCell,
          },
        ],
      },
    ],
  },
  {
    accessor: GeneralColumns.reviewStatus.name,
    Header: SortableHeader,
    title: GeneralColumns.reviewStatus.displayName,
    tooltip: '키워드의 심사와 관련된 현재 상태를 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.reviewStatus.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.reviewStatus.name,
            Header: EmptyHeader,
            width: 130,
            Cell: ReviewStatusCell,
          },
        ],
      },
    ],
  },
  {
    accessor: GeneralColumns.keywordBiddingAmount.name,
    Header: SortableHeader,
    title: GeneralColumns.keywordBiddingAmount.displayName,
    tooltip: '키워드의 입찰가가 별도 설정된 경우, 해당 정보를 표기합니다.',
    columns: [
      {
        accessor: GeneralColumns.keywordBiddingAmount.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.keywordBiddingAmount.name,
            Header: EmptyHeader,
            width: 132,
            Cell: KeywordBiddingAmountCell,
          },
        ],
      },
    ],
  },
  {
    accessor: GeneralColumns.score.name,
    Header: BaseHeader,
    title: GeneralColumns.score.displayName,
    tooltip: (
      <>
        키워드에 노출된 광고의 상대적 품질을 BAR형태로 표현합니다.
        <br />
        초록색이 많을 수록 상대적으로 품질이 높다는 의미입니다.
      </>
    ),
    columns: [
      {
        accessor: GeneralColumns.score.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.score.name,
            Header: EmptyHeader,
            width: 100,
            Cell: QiCell,
          },
        ],
      },
    ],
  },
  {
    accessor: GeneralColumns.exposureStatus.name,
    Header: BaseHeader,
    title: '노출현황',
    tooltip: (
      <>
        키워드에 노출된 광고의 미리보기이며,
        <br />
        입찰상황의 변화로 인해 실제 노출현황과 차이가 있을 수 있습니다.
      </>
    ),
    columns: [
      {
        accessor: GeneralColumns.exposureStatus.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.exposureStatus.name,
            Header: EmptyHeader,
            width: 95,
            Cell: ExposureStatusCell,
          },
        ],
      },
    ],
  },
  {
    accessor: GeneralColumns.landingUrlSetting.name,
    Header: SortableHeader,
    title: GeneralColumns.landingUrlSetting.displayName,
    tooltip: '키워드의 랜딩 URL 설정여부를 의미합니다.',
    columns: [
      {
        accessor: GeneralColumns.landingUrlSetting.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.landingUrlSetting.name,
            Header: EmptyHeader,
            width: 132,
            Cell: LandingUrlSettingCell,
          },
        ],
      },
    ],
  },
  {
    accessor: GeneralColumns.landingUrl.name,
    Header: BaseHeader,
    title: GeneralColumns.landingUrl.displayName,
    tooltip: '키워드에 설정된 랜딩 URL를 표기합니다.',
    columns: [
      {
        accessor: GeneralColumns.landingUrl.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.landingUrl.name,
            Header: EmptyHeader,
            width: 385,
            Cell: LandingUrlCell,
          },
        ],
      },
    ],
  },
  {
    accessor: GeneralColumns.campaign.name,
    Header: BaseHeader,
    title: GeneralColumns.campaign.displayName,
    tooltip: '키워드가 소속된 캠페인을 표기합니다.',
    columns: [
      {
        accessor: GeneralColumns.campaign.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.campaign.name,
            Header: EmptyHeader,
            width: 330,
            Cell: CampaignCell,
          },
        ],
      },
    ],
  },
  {
    accessor: GeneralColumns.adGroup.name,
    Header: BaseHeader,
    title: GeneralColumns.adGroup.displayName,
    tooltip: '키워드가 소속된 광고그룹을 표기합니다.',
    columns: [
      {
        accessor: GeneralColumns.adGroup.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: GeneralColumns.adGroup.name,
            Header: EmptyHeader,
            width: 330,
            Cell: AdGroupCell,
          },
        ],
      },
    ],
  },
  {
    accessor: EtcColumns.keywordId.name,
    Header: SortableHeader,
    title: EtcColumns.keywordId.displayName,
    tooltip: '키워드 마다 부여된 고유의 식별값을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.keywordId.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: EtcColumns.keywordId.name,
            Header: EmptyHeader,
            width: 160,
            Cell: IdCell,
          },
        ],
      },
    ],
  },
  {
    accessor: EtcColumns.createdDate.name,
    Header: SortableHeader,
    title: EtcColumns.createdDate.displayName,
    tooltip: '키워드가 최초 등록된 시간을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.createdDate.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: EtcColumns.createdDate.name,
            Header: EmptyHeader,
            width: 130,
            Cell: DateCell,
          },
        ],
      },
    ],
  },
  {
    accessor: EtcColumns.updatedDate.name,
    Header: SortableHeader,
    title: EtcColumns.updatedDate.displayName,
    tooltip: '키워드가 최종 수정된 시간을 의미합니다.',
    columns: [
      {
        accessor: EtcColumns.updatedDate.name,
        Header: EmptyHeader,
        columns: [
          {
            accessor: EtcColumns.updatedDate.name,
            Header: EmptyHeader,
            width: 130,
            Cell: DateCell,
          },
        ],
      },
    ],
  },
  ...extraMetricColumns,
]

export const temporaryKeywordBiddingAmountColumn = {
  accessor: 'temporaryKeywordBiddingAmount',
  Header: BaseHeader,
  title: GeneralColumns.keywordBiddingAmount.displayName,
  tooltip: '키워드의 입찰가가 별도 설정된 경우, 해당 정보를 표기합니다.',
  columns: [
    {
      accessor: 'temporaryKeywordBiddingAmount',
      Header: EmptyHeader,
      columns: [
        {
          accessor: 'temporaryKeywordBiddingAmount',
          Header: EmptyHeader,
          width: 132,
          Cell: KeywordBiddingAmountCell,
        },
      ],
    },
  ],
}

export const temporaryLandingUrlColumn = {
  accessor: 'temporaryLandingUrl',
  Header: BaseHeader,
  title: GeneralColumns.landingUrl.displayName,
  tooltip: '키워드에 설정된 랜딩 URL를 표기합니다.',
  columns: [
    {
      accessor: 'temporaryLandingUrl',
      Header: EmptyHeader,
      columns: [
        {
          accessor: 'temporaryLandingUrl',
          Header: EmptyHeader,
          width: 385,
          Cell: LandingUrlCell,
        },
      ],
    },
  ],
}

export const keywordBiddingAmountEditColumn = {
  accessor: 'keywordBiddingAmountEdit',
  Header: BaseHeader,
  title: '변경할 키워드 입찰가',
  columns: [
    {
      accessor: 'keywordBiddingAmountEdit',
      Header: EmptyHeader,
      columns: [
        {
          accessor: 'keywordBiddingAmountEdit',
          Header: EmptyHeader,
          width: 140,
          Cell: KeywordBiddingAmountEditCell,
        },
      ],
    },
  ],
}

export const landingUrlEditColumn = {
  accessor: 'landingUrlEdit',
  Header: BaseHeader,
  title: '변경할 랜딩 URL',
  columns: [
    {
      accessor: 'landingUrlEdit',
      Header: EmptyHeader,
      columns: [
        {
          accessor: 'landingUrlEdit',
          Header: EmptyHeader,
          width: 496,
          Cell: LandingUrlEditCell,
        },
      ],
    },
  ],
}
